<template>
  <div :class="{ 'sidebar-mode': isSidebar }">
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-body>
          <b-tabs card pills>
            <b-tab
              active
              :title-link-class="{ updateHack: sectionErrorCount['basic'] }"
            >
              <template #title>
                <i class="fas fa-building mr-1"></i>
                Informações Básicas
                <b-badge
                  :variant="!sectionErrorCount['basic'] ? 'success' : 'danger'"
                  class="ml-1"
                >
                  {{ sectionErrorCount["basic"] || "&#x2713;" }}
                </b-badge>
              </template>
              <b-form no-validate>
                <b-row class="mb-2">
                  <b-col>
                    <b-form-checkbox
                      v-model="company.active"
                      class="mb-auto"
                      :value="true"
                      :unchecked-value="false"
                      >Ativa?
                    </b-form-checkbox>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="9">
                    <b-form-group :label="i18n.fantasyName">
                      <b-form-input
                        v-model="company.fantasyName"
                        v-validate="rules.fantasyName"
                        type="text"
                        class="form-control"
                        data-section="basic"
                        aria-describedby="invalidFantasyName"
                        name="fantasyName"
                        :state="validateState('fantasyName')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidFantasyName">
                        {{ errors.first("fantasyName") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.cnpj">
                      <b-form-input
                        ref="cnpj"
                        v-model="company.cnpj"
                        v-mask="'##.###.###/####-##'"
                        v-validate="rules.cnpj"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidCNPJ"
                        name="cnpj"
                        data-section="basic"
                        :state="validateState('cnpj')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCNPJ">
                        {{ errors.first("cnpj") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="9">
                    <b-form-group :label="i18n.companyName">
                      <b-form-input
                        v-model="company.name"
                        v-validate="rules.name"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidName"
                        name="companyName"
                        data-section="basic"
                        :state="validateState('companyName')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidName">
                        {{ errors.first("companyName") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.municipalRegister">
                      <b-form-input
                        v-model="company.municipalRegister"
                        v-validate="rules.municipalRegister"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidInscricaoMunicipal"
                        name="municipalRegister"
                        data-section="basic"
                        :state="validateState('municipalRegister')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidInscricaoMunicipal">
                        {{ errors.first("municipalRegister") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.hqPhone">
                      <b-form-input
                        ref="phone"
                        v-model="company.phone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        v-validate="rules.phone"
                        type="tel"
                        class="form-control"
                        aria-describedby="invalidPhone"
                        name="hqPhone"
                        data-section="basic"
                        :state="validateState('hqPhone')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidPhone">
                        {{ errors.first("hqPhone") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.field">
                      <b-form-input
                        v-model="company.field"
                        v-validate="rules.field"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidAreaAtuacao"
                        name="field"
                        data-section="basic"
                        :state="validateState('field')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidAreaAtuacao">
                        {{ errors.first("field") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.porte">
                      <b-form-select
                        v-model="company.size"
                        v-validate="rules.size"
                        class="form-control"
                        :options="companySizeOpts"
                        aria-describedby="invalidPorte"
                        name="porte"
                        data-section="basic"
                        :state="validateState('porte')"
                      ></b-form-select>
                      <b-form-invalid-feedback id="invalidPorte">
                        {{ errors.first("porte") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group label="">
                      <b-form-checkbox
                        v-model="company.optSimples"
                        class="mb-auto"
                        :value="true"
                        :unchecked-value="false"
                        >Optante pelo Simples
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <hr />
                <b-row>
                  <b-col cols="12" lg="6">
                    <b-form-group :label="i18n.address">
                      <b-form-textarea
                        v-model="company.address"
                        v-validate="rules.address"
                        type="text"
                        class="form-control"
                        :rows="2"
                        :max-rows="2"
                        aria-describedby="invalidAddress"
                        name="address"
                        data-section="basic"
                        :state="validateState('address')"
                      ></b-form-textarea>
                      <b-form-invalid-feedback id="invalidAddress">
                        {{ errors.first("address") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.state">
                      <b-form-select
                        v-model="company.state"
                        v-validate="rules.state"
                        class="form-control"
                        :options="statesOpts"
                        aria-describedby="invalidState"
                        name="state"
                        data-section="basic"
                        :state="validateState('state')"
                        @change="refreshCities"
                      ></b-form-select>
                      <b-form-invalid-feedback id="invalidState">
                        {{ errors.first("state") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.city">
                      <b-form-select
                        v-model="company.city"
                        v-validate="rules.city"
                        class="form-control"
                        :options="citiesOpts"
                        aria-describedby="invalidCity"
                        name="city"
                        data-section="basic"
                        :state="validateState('city')"
                      ></b-form-select>
                      <b-form-invalid-feedback id="invalidCity">
                        {{ errors.first("city") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="3">
                    <b-form-group :label="i18n.zipCode">
                      <b-form-input
                        ref="zipCode"
                        v-model="company.zipCode"
                        v-validate="rules.zipCode"
                        v-mask="'#####-###'"
                        class="form-control"
                        aria-describedby="invalidZipCode"
                        name="zipCode"
                        data-section="basic"
                        :state="validateState('zipCode')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidZipCode">
                        {{ errors.first("zipCode") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>
            <b-tab
              :title-link-class="{ updateHack: sectionErrorCount['finance'] }"
            >
              <template #title>
                <i class="fas fa-dollar-sign mr-1"></i>
                Informações Financeiras
                <b-badge
                  :variant="
                    !sectionErrorCount['finance'] ? 'success' : 'danger'
                  "
                  class="ml-1"
                >
                  {{ sectionErrorCount["finance"] || "&#x2713;" }}
                </b-badge>
              </template>
              <b-form no-validate>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.responsavelFinanceiro">
                      <b-form-input
                        v-model="company.financial.accountable.name"
                        v-validate="rules.financial.accountable"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidResponsavelFinanceiro"
                        name="responsavelFinanceiro"
                        data-section="finance"
                        :state="validateState('responsavelFinanceiro')"
                      ></b-form-input>
                      <b-form-invalid-feedback
                        id="invalidResponsavelFinanceiro"
                      >
                        {{ errors.first("responsavelFinanceiro") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.financePhone">
                      <b-form-input
                        ref="financePhone"
                        v-model="company.financial.accountable.phone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        v-validate="rules.financial.phone"
                        type="tel"
                        class="form-control"
                        aria-describedby="invalidFinancePhone"
                        name="financePhone"
                        data-section="finance"
                        :state="validateState('financePhone')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidFinancePhone">
                        {{ errors.first("financePhone") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.emailFinanceiro">
                      <b-form-input
                        v-model="company.financial.accountable.email"
                        v-validate="rules.financial.email"
                        type="email"
                        class="form-control"
                        aria-describedby="invalidEmailFinanceiro"
                        name="emailFinanceiro"
                        data-section="finance"
                        :state="validateState('emailFinanceiro')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidEmailFinanceiro">
                        {{ errors.first("emailFinanceiro") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.emailNotaFiscal">
                      <b-form-input
                        v-model="company.financial.invoiceEmail"
                        v-validate="rules.financial.invoiceEmail"
                        type="email"
                        class="form-control"
                        aria-describedby="invalidEmailNF"
                        name="emailNotaFiscal"
                        data-section="finance"
                        :state="validateState('emailNotaFiscal')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidEmailNF">
                        {{ errors.first("emailNotaFiscal") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.hourlyRate">
                      <b-form-input
                        v-model.number="company.financial.hourlyRate"
                        v-validate="rules.financial.hourlyRate"
                        type="number"
                        min="0"
                        step="0.01"
                        class="form-control"
                        aria-describedby="invalidHourlyRate"
                        name="hourlyRate"
                        data-section="finance"
                        :state="validateState('hourlyRate')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidHourlyRate">
                        {{ errors.first("hourlyRate") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group label="" label-for="showTimeCost">
                      <b-form-checkbox
                        id="showTimeCost"
                        v-model="company.financial.showTimeCost"
                        name="showTimeCost"
                        class="mt-lg-4"
                      >
                        {{ i18n.showTimeCost }}
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>
            <b-tab
              :title-link-class="{
                updateHack: sectionErrorCount['compliance'],
              }"
            >
              <template #title>
                <i class="fas fa-shield-alt mr-1"></i>
                Compliance
                <b-badge
                  :variant="
                    !sectionErrorCount['compliance'] ? 'success' : 'danger'
                  "
                  class="ml-1"
                >
                  {{ sectionErrorCount["compliance"] || "&#x2713;" }}
                </b-badge>
              </template>
              <b-form no-validate>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.coName">
                      <b-form-input
                        v-model="company.compliance.accountable.name"
                        v-validate="rules.compliance.coName"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidComplianceOfficer"
                        name="complianceOfficer"
                        data-section="compliance"
                        :state="validateState('complianceOfficer')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidComplianceOfficer">
                        {{ errors.first("complianceOfficer") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.coPosition">
                      <b-form-input
                        v-model="company.compliance.accountable.position"
                        v-validate="rules.compliance.coPosition"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidCOPosition"
                        name="coPosition"
                        data-section="compliance"
                        :state="validateState('coPosition')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCOPosition">
                        {{ errors.first("coPosition") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.coSector">
                      <b-form-select
                        v-model="company.compliance.accountable.sector"
                        v-validate="rules.compliance.coSector"
                        class="form-control"
                        :options="sectorOptions"
                        :disabled="loading || !editing || !hasSectors"
                        aria-describedby="invalidCOSector"
                        name="coSector"
                        data-section="compliance"
                        :state="validateState('coSector')"
                      ></b-form-select>
                      <b-form-invalid-feedback id="invalidCOSector">
                        {{ errors.first("coSector") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.coPhone">
                      <b-form-input
                        ref="coPhone"
                        v-model="company.compliance.accountable.phone"
                        v-validate="rules.compliance.coPhone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidCOPhone"
                        name="coPhone"
                        data-section="compliance"
                        :state="validateState('coPhone')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCOPhone">
                        {{ errors.first("coPhone") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.coEmail">
                      <b-form-input
                        v-model="company.compliance.accountable.email"
                        v-validate="rules.compliance.coEmail"
                        type="email"
                        class="form-control"
                        aria-describedby="invalidCOEmail"
                        name="coEmail"
                        data-section="compliance"
                        :state="validateState('coEmail')"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCOEmail">
                        {{ errors.first("coEmail") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.coObservation">
                      <b-form-textarea
                        v-model="company.compliance.observation"
                        v-validate="rules.compliance.coObservation"
                        :rows="3"
                        :max-rows="6"
                        aria-describedby="invalidCOObservation"
                        name="coObservation"
                        :state="validateState('coObservation')"
                        data-section="compliance"
                      >
                      </b-form-textarea>
                      <b-form-invalid-feedback id="invalidCOObservation">
                        {{ errors.first("coObservation") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.complianceEmail">
                      <b-form-input
                        v-model="company.compliance.email"
                        v-validate="rules.compliance.complianceEmail"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidCEmail"
                        name="complianceEmail"
                        :state="validateState('complianceEmail')"
                        data-section="compliance"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCEmail">
                        {{ errors.first("complianceEmail") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.compliancePhone">
                      <b-form-input
                        ref="compliancePhone"
                        v-model="company.compliance.phone"
                        v-validate="rules.compliance.compliancePhone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidCPhone"
                        name="compliancePhone"
                        :state="validateState('compliancePhone')"
                        data-section="compliance"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidCPhone">
                        {{ errors.first("compliancePhone") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.proceduresNotes">
                      <b-form-textarea
                        v-model="company.compliance.proceduresNotes"
                        v-validate="rules.compliance.proceduresNotes"
                        :rows="3"
                        :max-rows="6"
                        aria-describedby="invalidProceduresNotes"
                        name="proceduresNotes"
                        :state="validateState('proceduresNotes')"
                        data-section="compliance"
                      >
                      </b-form-textarea>
                      <b-form-invalid-feedback id="invalidProceduresNotes">
                        {{ errors.first("proceduresNotes") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.ethicsConduct">
                      <template v-if="files.ethicsConduct.current">
                        <b-button
                          variant="link"
                          @click="downloadFile(files.ethicsConduct)"
                          >Ver atual
                        </b-button>
                        <b-button
                          variant="light"
                          @click="files.ethicsConduct.current = null"
                        >
                          Substituir
                        </b-button>
                      </template>
                      <template v-else>
                        <b-form-file
                          v-model="files.ethicsConduct.file"
                          placeholder="Selecione um arquivo PDF."
                        ></b-form-file>
                      </template>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.compliancePolicy">
                      <template v-if="files.policy.current">
                        <b-button
                          variant="link"
                          @click="downloadFile(files.policy)"
                          >Ver atual
                        </b-button>
                        <b-button
                          variant="light"
                          @click="files.policy.current = null"
                          >Substituir
                        </b-button>
                      </template>
                      <template v-else>
                        <b-form-file
                          v-model="files.policy.file"
                          placeholder="Selecione um arquivo PDF."
                        ></b-form-file>
                      </template>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.procedures">
                      <template v-if="files.procedures.current">
                        <b-button
                          variant="link"
                          @click="downloadFile(files.procedures)"
                          >Ver atual
                        </b-button>
                        <b-button
                          variant="light"
                          @click="files.procedures.current = null"
                          >Substituir
                        </b-button>
                      </template>
                      <template v-else>
                        <b-form-file
                          v-model="files.procedures.file"
                          placeholder="Selecione um arquivo PDF."
                        ></b-form-file>
                      </template>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col>
                    <b-form-group :label="i18n.committee">
                      <template v-if="files.committee.current">
                        <b-button
                          variant="link"
                          @click="downloadFile(files.committee)"
                          >Ver atual
                        </b-button>
                        <b-button
                          variant="light"
                          @click="files.committee.current = null"
                          >Substituir
                        </b-button>
                      </template>
                      <template v-else>
                        <b-form-file
                          v-model="files.committee.file"
                          placeholder="Selecione um arquivo PDF."
                        ></b-form-file>
                      </template>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>
            <b-tab
              :title-link-class="{
                updateHack: sectionErrorCount['phoneService'],
              }"
            >
              <template #title>
                <i class="fas fa-phone mr-1"></i>
                Telefone
                <b-badge
                  :variant="
                    !sectionErrorCount['phoneService'] ? 'success' : 'danger'
                  "
                  class="ml-1"
                >
                  {{ sectionErrorCount["phoneService"] || "&#x2713;" }}
                </b-badge>
              </template>
              <b-form no-validate>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group label="">
                      <b-form-checkbox
                        v-model="company.phoneService.hasService"
                        class="mb-auto"
                        :value="true"
                        :unchecked-value="false"
                        >Possui serviços de recepção de denúncias por meio
                        telefônico?
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group label="">
                      <b-form-checkbox
                        v-model="company.phoneService.allocatedWithUs"
                        class="mb-auto"
                        :value="true"
                        :unchecked-value="false"
                        >O serviço está alocado na Conformità?
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group label="">
                      <b-form-checkbox
                        v-model="company.phoneService.shared"
                        class="mb-auto"
                        :value="true"
                        :unchecked-value="false"
                        >O serviço é compartilhado?
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.phoneSerivcePhone">
                      <b-form-input
                        ref="phoneServicePhone"
                        v-model="company.phoneService.phone"
                        v-validate="rules.phoneService.phone"
                        v-mask="['(##) ####-####', '(##) #####-####']"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidPhoneSerivcePhone"
                        name="phoneServicePhone"
                        :state="validateState('phoneServicePhone')"
                        data-section="phoneService"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidPhoneSerivcePhone">
                        {{ errors.first("phoneServicePhone") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" lg="4">
                    <b-form-group :label="i18n.phoneSerivceCode">
                      <b-form-input
                        v-model="company.phoneService.code"
                        v-validate="rules.phoneService.code"
                        type="text"
                        class="form-control"
                        aria-describedby="invalidPhoneSerivceCode"
                        name="phoneSerivceCode"
                        :state="validateState('phoneSerivceCode')"
                        data-section="phoneService"
                      ></b-form-input>
                      <b-form-invalid-feedback id="invalidPhoneSerivceCode">
                        {{ errors.first("phoneSerivceCode") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="8">
                    <b-form-group :label="i18n.phoneSerivceObs">
                      <b-form-textarea
                        v-model="company.phoneService.observation"
                        v-validate="rules.phoneService.observation"
                        type="text"
                        class="form-control"
                        :rows="2"
                        :max-rows="2"
                        aria-describedby="invalidPhoneSerivceObs"
                        name="phoneSerivceObs"
                        :state="validateState('phoneSerivceObs')"
                        data-section="phoneService"
                      ></b-form-textarea>
                      <b-form-invalid-feedback id="invalidPhoneSerivceObs">
                        {{ errors.first("phoneSerivceObs") }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>
            <b-tab
              v-if="profile.role === 'root'"
              :title-link-class="{
                updateHack: sectionErrorCount['managedBy'],
              }"
            >
              <template #title>
                <i class="fas fa-handshake mr-1"></i>
                Gestão Terceirizada
                <b-badge
                  :variant="
                    !sectionErrorCount['managedBy'] ? 'success' : 'danger'
                  "
                  class="ml-1"
                >
                  {{ sectionErrorCount["managedBy"] || "&#x2713;" }}
                </b-badge>
              </template>
              <b-form no-validate>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group label="">
                      <b-form-checkbox
                        v-model="managedByOtherCompany"
                        class="mb-auto"
                        :value="true"
                        :unchecked-value="false"
                        >Gerenciada por outra empresa?
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12" lg="4">
                    <b-form-group label="Empresa">
                      <b-form-select
                        v-model="company.managedBy"
                        v-validate="rules.managedBy"
                        class="form-control"
                        data-section="managedBy"
                        name="managedBy"
                        :options="companiesOpts"
                        :disabled="!managedByOtherCompany"
                        aria-describedby="invalidManagedBy"
                        :state="validateState('managedBy')"
                      ></b-form-select>
                      <b-form-invalid-feedback id="invalidManagedBy">
                        {{
                          (errors.first("managedBy") || "").replace(
                            "managedBy",
                            "Empresa"
                          )
                        }}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-tab>
          </b-tabs>
          <b-card-footer>
            <span v-if="upload.visible">Enviando {{ upload.filename }}...</span>
            <b-progress
              v-if="upload.visible"
              class="mb-2"
              :value="upload.value"
              :max="100"
              show-progress
            ></b-progress>
            <b-button
              variant="primary"
              class="px-4"
              :disabled="loading"
              @click="onSaveClicked"
              >Salvar</b-button
            >
            <b-button class="px-4 ml-1" :disabled="loading" @click="goBack"
              >Cancelar</b-button
            >
          </b-card-footer>
        </b-card>
      </b-col>
      <a
        ref="download"
        class="invisible"
        target="_blank"
        :download="download.name"
        :href="download.link"
      ></a>
    </b-row>
  </div>
</template>

<script>
import {
  getCompany,
  editCompany,
  newCompany,
  sendCompanyFile,
  getCompanySize,
  getCompanies,
  getClassificationValues,
} from "../../api/company";
import { getStates, getCities } from "../../api/geo";
import { ValidatorDictionary } from "../../i18n";

import { mapGetters } from "vuex";

import { mask } from "vue-the-mask";

export default {
  name: "CompanyView",
  directives: { mask },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    isSidebar: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      i18n: ValidatorDictionary.attributes,
      managedByOtherCompany: false,
      companies: [],
      download: {
        name: null,
        link: null,
      },
      loading: false,
      company: {
        phoneService: {},
        financial: {
          accountable: {},
        },
        compliance: {
          accountable: {},
          files: [],
        },
      },
      files: {
        ethicsConduct: { current: null, file: null, name: "Código de Ética" },
        policy: { current: null, file: null, name: "Política de Compliance" },
        procedures: { current: null, file: null, name: "Procedimentos" },
        committee: { current: null, file: null, name: "Comitê" },
      },
      editing: false,
      states: [],
      cities: [],
      companySize: [],
      upload: {
        value: 0,
        visible: false,
        filename: "",
      },
      sectionErrorCount: {},
      sectors: [],
    };
  },
  computed: {
    ...mapGetters(["profile", "portalBucket"]),
    rules() {
      return {
        managedBy: { required: this.managedByOtherCompany },
        fantasyName: { required: true },
        name: { required: true },
        cnpj: { required: true, cnpj: true },
        municipalRegister: { required: true },
        phone: { required: false },
        address: { required: true },
        city: { required: true },
        state: { required: true },
        zipCode: { required: false },
        field: { required: true },
        size: { required: false },

        financial: {
          accountable: { required: false },
          phone: { required: false },
          email: { required: false, email: true },
          invoiceEmail: { required: false, email: true },
          hourlyRate: { required: false, min_value: 0 },
        },

        compliance: {
          coName: { required: false },
          coPosition: { required: false },
          coSector: { required: false },
          coPhone: { required: false },
          coEmail: { required: false, email: true },
          coObservation: { required: false },
          complianceEmail: { required: false, email: true },
          compliancePhone: { required: false },

          proceduresNotes: { required: false },
          ethicsConduct: { required: false },
          compliancePolicy: { required: false },
          procedures: { required: false },
          committee: { required: false },
        },
        phoneService: {
          phone: { required: false },
          code: { required: false },
          observation: { required: false },
        },
      };
    },
    companiesOpts() {
      const opts = [];
      for (const company of this.companies) {
        opts.push({ value: company._id, text: company.fantasyName });
      }
      return opts;
    },
    statesOpts() {
      const opts = [];
      opts.push({
        value: undefined,
        text: "Por favor selecione um estado",
        disabled: true,
      });
      for (const state of this.states) {
        opts.push({ value: state._id, text: state.name });
      }
      return opts;
    },
    citiesOpts() {
      const opts = [];
      opts.push({
        value: undefined,
        text: "Por favor selecione uma cidade",
        disabled: true,
      });
      for (const city of this.cities) {
        opts.push({ value: city.code, text: city.name });
      }
      return opts;
    },
    companySizeOpts() {
      const opts = [];
      opts.push({ value: undefined, text: "Não especificado" });
      for (const size of this.companySize) {
        opts.push({ value: size._id, text: size.name });
      }
      return opts;
    },
    hasSectors() {
      return this.sectors.length > 0;
    },
    sectorOptions() {
      const opts = [
        {
          value: "",
          text: this.hasSectors
            ? "Por favor selecione um setor"
            : "Nenhum setor cadastrado",
          disabled: true,
        },
      ];

      for (const sector of this.sectors) {
        opts.push({ value: sector, text: sector });
      }

      return opts;
    },
  },
  async created() {
    this.editing = parseInt(this.id) == this.id;

    this.loadStates();
    this.loadCompanySize();

    if (this.editing) {
      await this.loadSectors(this.id);
      const response = await getCompany(this.id);
      const company = response.data;
      this.loadCities(company.state);

      company.phoneService = company.phoneService || {};

      company.financial = company.financial || {};
      company.financial.accountable = company.financial.accountable || {};

      company.compliance = company.compliance || {};
      company.compliance.accountable = company.compliance.accountable || {};

      if (company.compliance.files) {
        this.unpackCurrentFiles(company);
      }

      const currentSector = company?.compliance?.accountable?.sector;
      if (
        currentSector &&
        !this.sectors.includes(String(currentSector).trim())
      ) {
        company.compliance.accountable.sector = "";
      }

      this.company = company;
      this.managedByOtherCompany = !!this.company.managedBy;
      const updateEls = [
        "cnpj",
        "phone",
        "financePhone",
        "zipCode",
        "coPhone",
        "compliancePhone",
        "phoneServicePhone",
      ];
      this.$nextTick(() => {
        for (const id of updateEls) {
          this.$refs[id].$el.oninput({ isTrusted: true });
        }
        this.validateFields();
      });
    }

    this.loadCompanies();
  },
  methods: {
    addFile() {
      this.files.push({
        _id: `new-${this.files.length}`,
      });
    },
    unpackCurrentFiles(company) {
      const oldFiles = company.compliance.oldFiles || {};

      if (oldFiles.ethicsConduct) {
        this.files.ethicsConduct.current = oldFiles.ethicsConduct;
      }
      if (oldFiles.policy) {
        this.files.policy.current = oldFiles.policy;
      }
      if (oldFiles.procedures) {
        this.files.procedures.current = oldFiles.procedures;
      }
      if (oldFiles.committee) {
        this.files.committee.current = oldFiles.committee;
      }
    },
    goBack() {
      if (this.isSidebar) {
        this.$emit("close");
      } else {
        this.$router.go(-1);
      }
    },
    validateState(ref) {
      if (
        this.vFields[ref] &&
        (this.vFields[ref].dirty || this.vFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },

    downloadFile(file) {
      const filename = file.path;
      this.download.name = `${file.name}.${filename.substr(
        filename.lastIndexOf(".")
      )}`;
      this.download.link = `https://${this.portalBucket}/${filename}`;
      this.$nextTick(() => {
        this.$refs["download"].click();
      });
    },

    async onSaveClicked() {
      const filesToUpload = [];
      const filesToDelete = [];

      let totalSize = 0;

      for (const key in this.files) {
        const item = this.files[key];
        if (item.file) {
          filesToUpload.push(item);
          totalSize += item.file.size;
        }
      }

      const validated = await this.validateFields();
      if (!validated) return;

      const payload = JSON.parse(JSON.stringify(this.company));
      payload.cnpj = payload.cnpj.replace(/[^\d]/g, "");
      if (payload.phone) payload.phone = payload.phone.replace(/[^\d]/g, "");
      if (payload.zipCode)
        payload.zipCode = payload.zipCode.replace(/[^\d]/g, "");
      if (payload.financial.accountable.phone)
        payload.financial.accountable.phone =
          payload.financial.accountable.phone.replace(/[^\d]/g, "");
      if (payload.compliance.accountable.phone)
        payload.compliance.accountable.phone =
          payload.compliance.accountable.phone.replace(/[^\d]/g, "");
      if (payload.compliance.phone)
        payload.compliance.phone = payload.compliance.phone.replace(
          /[^\d]/g,
          ""
        );
      if (payload.phoneService.phone)
        payload.phoneService.phone = payload.phoneService.phone.replace(
          /[^\d]/g,
          ""
        );

      if (!this.managedByOtherCompany) {
        payload.managedBy = null;
      }

      this.loading = true;

      let action = this.editing ? editCompany : newCompany;

      try {
        const response = await action(payload);

        if (!this.editing) {
          this.company._id = response.data._id;
        }

        let loaded = 0;
        this.upload.visible = true;
        for (const key in this.files) {
          const item = this.files[key];
          if (item.file) {
            this.upload.filename = item.name;
            await sendCompanyFile(this.company._id, item, (evt) => {
              this.upload.value = ((loaded + evt.loaded) / totalSize) * 100;
            });
            loaded += item.file.size;
          }
        }
        this.upload.visible = false;

        this.loading = false;

        if (this.isSidebar) {
          this.$emit("saved", response.data);
        } else {
          this.$router.go(-1);
        }
      } catch (error) {
        this.loading = false;
        this.upload.visible = false;
        console.error("Erro ao salvar empresa:", error);

        const message =
          error.response?.data?.message ||
          "Ocorreu um erro ao salvar a empresa.";
        this.$bvToast.toast(message, {
          title: "Erro",
          toastClass: "custom-toast custom-toast-error",
          variant: "light",
          solid: true,
          autoHideDelay: 5000,
        });
      }
    },
    async loadCompanies() {
      const response = await getCompanies();
      this.companies = response.data;
      this.companies = this.companies.filter(
        (company) => company._id !== this.company._id
      );
    },
    async loadStates() {
      const response = await getStates();
      this.states = response.data;
    },
    async loadCompanySize() {
      const response = await getCompanySize();
      this.companySize = response.data;
    },
    async loadSectors(companyId) {
      try {
        const response = await getClassificationValues(companyId, 7);
        this.sectors = (response.data || [])
          .map((item) => (item?.value || "").trim())
          .filter(Boolean);
      } catch (error) {
        this.sectors = [];
      }
    },
    async loadCities(state) {
      const response = await getCities(state);
      this.cities = response.data;
    },
    async refreshCities(state) {
      this.company.city = undefined;
      await this.loadCities(state);
    },

    async validateFields() {
      this.sectionErrorCount = {};
      const validated = await this.$validator.validateAll();
      if (!validated) {
        for (const error of this.errors.items) {
          const field = error.field;
          let el = document.getElementsByName(field)[0];
          if (el && el.type === "file") {
            el = el.parentElement;
          }
          if (el && el.hasAttribute("data-section")) {
            const section = el.getAttribute("data-section");
            this.sectionErrorCount[section] =
              this.sectionErrorCount[section] || 0;
            this.sectionErrorCount[section] =
              this.sectionErrorCount[section] + 1;
          }
        }
      }

      this.$nextTick(() => this.$forceUpdate());

      return validated;
    },
  },
};
</script>

<style>
.custom-file-input ~ .custom-file-label::after {
  content: "Escolher";
}

/* Estilos para modo sidebar */
.sidebar-mode .card {
  border: none;
  box-shadow: none;
}

.sidebar-mode .card-header {
  background-color: transparent;
  border-bottom: 1px solid #e9ecef;
  padding: 0;
}

.sidebar-mode .card-footer {
  position: sticky;
  bottom: 0;
  background-color: #fff;
  border-top: 1px solid #e9ecef;
  padding: 1rem;
  z-index: 10;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

/* Remover borda do card principal */
::v-deep .card {
  border: none;
  box-shadow: none;
}

::v-deep .card-body {
  padding: 0;
}

/* Estilos das tabs */
::v-deep .nav-pills .nav-link {
  border-radius: 8px;
  padding: 0.6rem 1rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  color: #6c757d;
  background-color: #f8f9fa;
  border: 1px solid #e9ecef;
  transition: all 0.3s ease;
  font-weight: 500;
  font-size: 0.9rem;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}

::v-deep .nav-pills .nav-link:hover {
  background-color: #e9ecef;
  color: #495057;
  border-color: #dee2e6;
  transform: translateY(-1px);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

::v-deep .nav-pills .nav-link.active {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  color: #fff;
  border-color: #007bff;
  box-shadow: 0 4px 8px rgba(0, 123, 255, 0.3);
}

::v-deep .nav-pills .nav-link i {
  font-size: 0.85rem;
}

::v-deep .nav-pills .nav-link .badge {
  font-size: 0.65rem;
  padding: 0.2rem 0.4rem;
  border-radius: 10px;
  font-weight: 600;
}

::v-deep .card-header {
  background-color: #fff;
  border-bottom: none;
  padding: 1rem 1.25rem 0;
}

::v-deep .tab-content {
  padding: 1.5rem;
  background-color: #fff;
}

::v-deep .tab-content .tab-pane {
  border: none;
}

/* Estilos dos inputs do formulário */
::v-deep .form-control,
::v-deep .custom-select {
  border: 1px solid #e3e6ea;
  border-radius: 6px;
  padding: 0.6rem 0.9rem;
  font-size: 0.95rem;
  transition: all 0.2s ease;
}

::v-deep .form-control:focus,
::v-deep .custom-select:focus {
  border-color: #007bff;
  box-shadow: 0 0 0 3px rgba(0, 123, 255, 0.1);
  outline: none;
}

::v-deep .form-group label {
  font-weight: 600;
  color: #495057;
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

::v-deep .custom-checkbox label {
  font-weight: 500;
  color: #6c757d;
}

::v-deep .form-row {
  margin-bottom: 0.5rem;
}

::v-deep hr {
  border-top: 2px solid #f1f3f5;
  margin: 1.5rem 0;
}

/* Botões do formulário */
::v-deep .card-footer .btn {
  border-radius: 6px;
  padding: 0.6rem 1.5rem;
  font-weight: 500;
  transition: all 0.3s ease;
}

::v-deep .card-footer .btn-primary {
  background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
  border: none;
  box-shadow: 0 2px 6px rgba(0, 123, 255, 0.3);
}

::v-deep .card-footer .btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 10px rgba(0, 123, 255, 0.4);
}

::v-deep .card-footer .btn-primary:disabled {
  opacity: 0.6;
  transform: none;
}

::v-deep .card-footer {
  background-color: #f8f9fa;
  border-top: 2px solid #e9ecef;
  padding: 1.25rem;
}

.sidebar-mode ::v-deep .nav-pills {
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 1rem 1rem 0.5rem;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e0 #f7fafc;
}

.sidebar-mode ::v-deep .nav-pills::-webkit-scrollbar {
  height: 6px;
}

.sidebar-mode ::v-deep .nav-pills::-webkit-scrollbar-track {
  background: #f7fafc;
  border-radius: 10px;
}

.sidebar-mode ::v-deep .nav-pills::-webkit-scrollbar-thumb {
  background: #cbd5e0;
  border-radius: 10px;
}

.sidebar-mode ::v-deep .nav-pills::-webkit-scrollbar-thumb:hover {
  background: #a0aec0;
}

.sidebar-mode ::v-deep .tab-content {
  padding: 1rem;
}
</style>
